import { createContext } from 'react';
import { ButtonGroupProps } from './button-group';

export interface ButtonGroupContextValue extends ButtonGroupProps {
  /**
   * @default false
   */
  isDisabled?: boolean;
}

export const ButtonGroupContext = createContext<ButtonGroupContextValue>({});
